import React from 'react';
import { useIntl } from 'react-intl';
import Grid from '@mui/material/Grid';
import { getDomainConfig } from '@raisin/cp-utils';
import { CountryPicker } from '../../../../components';
import { CustomLink } from '../../../../components/CustomLink';
import { useMarkets } from '../../../../hooks/useMarkets';
import { resolveUrlWithLocale } from '../../../../utils/helpers';
import { trackFooterNavigation } from '../../../../utils/Layout/footer';
import Credits from '../Credits';
import * as S from './styles';
const getCurrentYearCopyright = () => `© ${new Date().getFullYear()} `;
const FooterImprint = React.memo(({ copyright, legalLinks, hideCountryPicker = false, credits }) => {
    const { locale } = useIntl();
    const pickerConfig = useMarkets();
    const { basePath } = getDomainConfig(locale);
    return (React.createElement(S.Container, { "data-testid": "footerImprint-wrapper", container: true },
        React.createElement(S.Grid, { item: true, order: { xs: 1, md: 1 } },
            React.createElement(S.List, null,
                copyright && (React.createElement(S.ListItem, null,
                    React.createElement(S.Typography, { variant: "body1", testId: "footerImprint-copyright" },
                        getCurrentYearCopyright(),
                        copyright))),
                legalLinks &&
                    legalLinks.map((link) => (React.createElement(S.ListItem, { key: link === null || link === void 0 ? void 0 : link.title }, link.href === '#uc-corner-modal-show' ? (React.createElement(CustomLink, { href: link.href },
                        React.createElement(S.Typography, { variant: "body1" },
                            React.createElement(S.Link, { href: "#uc-corner-modal-show", onClick: (e) => {
                                    var _a;
                                    e.preventDefault();
                                    // @ts-ignore
                                    (_a = window.UC_UI) === null || _a === void 0 ? void 0 : _a.showSecondLayer();
                                    trackFooterNavigation(link.href);
                                }, "data-testid": `legalLinks-link-${link === null || link === void 0 ? void 0 : link.title}` }, link === null || link === void 0 ? void 0 : link.title)))) : (React.createElement(CustomLink, { href: resolveUrlWithLocale(link === null || link === void 0 ? void 0 : link.href, basePath) },
                        React.createElement(S.Typography, { variant: "body1" },
                            React.createElement(S.Link, { href: resolveUrlWithLocale(link === null || link === void 0 ? void 0 : link.href, basePath), onClick: () => trackFooterNavigation(resolveUrlWithLocale(link.href, basePath)), "data-testid": `legalLinks-link-${link === null || link === void 0 ? void 0 : link.title}` }, link === null || link === void 0 ? void 0 : link.title))))))))),
        (credits === null || credits === void 0 ? void 0 : credits.length) > 0 && (React.createElement(Grid, { item: true, order: { xs: 2, md: 2 } },
            React.createElement(Credits, { credits: credits }))),
        !hideCountryPicker && (React.createElement(Grid, { item: true, order: { xs: 1, md: 3 } },
            React.createElement(CountryPicker, { locale: locale, align: "right", markets: pickerConfig })))));
});
FooterImprint.displayName = 'FooterImprint';
export default FooterImprint;
//# sourceMappingURL=index.js.map